<template lang="pug">
.content.cardInicial
  h2.titulo-the-home Bem-Vindo à Central do Interessado!

  el-row.cards-mod(
    type="flex",
    justify="center",
    :gutter="30"
  )
    el-col.card-mod(
      v-for="funcionalidade in menu",
      v-if="funcionalidade.exibir !== false"
      :key="funcionalidade.codigo",
      @click.native="redirecionaFuncionalidade(funcionalidade.routeName)",
    )
      el-card.center
        div.center(slot="header")
          img.func-card(:src='imgFuncionalidades(funcionalidade.img)')
        span {{ funcionalidade.nome }}

</template>

<script>
import { mapGetters } from 'vuex'

export default {

  computed: {
    ...mapGetters({
      menu: 'menu/menu'
    })
  },

  methods: {
    redirecionaFuncionalidade (route) {
      this.$router.push({
        name: route
      })
    },

    imgFuncionalidades (img) {
      return 'static/' + img
    }
  }
}
</script>

<style lang="scss" scoped>

  .content {
    margin-left: auto;
    margin-right: auto;
    flex-direction: column;
    display: inline;
    align-items: center;
    align-content: center;
    justify-content: center;
    .cards-mod {
      margin: 0 !important;
      display: flex;
      padding-right: 150px;
      flex-wrap: wrap;
      * {
        width: fit-content;
        flex-wrap: wrap;
      }
    }

    .card-mod {
      height: 299px;
      width: 268px;
      flex-wrap: wrap;
      cursor: pointer;
      margin-bottom: 30px;
      text-align: center;
      word-wrap:  normal;

      > :hover{
        transform: scale(1.05);
        transition-property: 2s;
      }
    }

    .card-mod-disabled {
      height: 299px;
      width: 268px;
      flex-wrap: wrap;
      cursor: pointer;
      margin-bottom: 30px;
      text-align: center;
      word-wrap:  normal;
      opacity: 0.7;
    }

    .center {
      width: 100%;
      height: 100%;
    }

    .func-card {
      width: 180px;
      height: 180px;
    }

    .titulo-the-home {
      h1, h2 {
        font-size: 1.2em;
        font-weight: normal;
      }
      text-align: center;
      padding: 10px 150px 10px 10px;
    }
    color:#666674 !important;
  }

@media (max-width: 780px) {
  .cardInicial {
    right: 40px;
  }
}

@media (max-width: 1256px) {
  .content .titulo-the-home {
    padding: 70px 110px 10px 10px;
  }
}

@media (max-width: 1365px) {
  .content {
    position: absolute;
    .cards-mod {
      padding-right: 60px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/screens/central/Home.vue